export default __webpack_public_path__ + "static/media/score.7ea2d7e6.svg";